<style lang="less">
@import "../styles/menu.less";
</style>

<template>
  <!-- 点击元数据menuShow未改变 -->
  <!--  -->
  <Menu
    ref="sideMenu"
    :open-names="openNames"
    :active-name="projectId + '-' + routerName"
    :theme="menuTheme"
    accordion
    @on-open-change="menuResize"
    @on-select="changeMenu"
  >
    <template v-for="item in menuList">
      <side-menu-item
        v-if="item.children && item.children.length > 0"
        :iconSize="iconSize"
        :parentItem="item"
        :key="'menu' + item.name"
      >
      </side-menu-item>
      <MenuItem v-else :name="item.projectId + '-' + item.name" :key="this">
        <Icon
          :custom="'i-custom icon-' + item.icon"
          :size="iconSize"
          :key="'icon' + item.name"
        ></Icon>
        <span class="layout-text" :key="'title' + item.id"
          >{{ item.title }}
          <add-dashboard
            v-if="item.name === 'Dashboard'"
            style="margin-left: 50px"
          ></add-dashboard>
        </span>
      </MenuItem>
    </template>
  </Menu>
</template>

<script>
import sideMenuItem from "./side-menu-item";
import addDashboard from "@/views/dashboards/add-dashboard";
import { mapState, mapMutations } from "vuex";

export default {
  name: "sidebarMenu",
  components: {
    sideMenuItem,
    addDashboard,
  },
  data() {
    return {
      routerName: "",
      projectId: 0,
      activeStr: "",
      url: "",
      isDownClock: this.isDown,
      // url: window.location.pathname.split("/"),
    };
  },
  props: {
    // menuList: Array,
    iconSize: Number,
    menuShow: [Boolean, String],
    isDown: [Boolean],
    menuTheme: {
      type: String,
      default: "dark",
    },
    openNames: {
      type: Array,
    },
  },

  computed: {
    ...mapState({
      menuList: (state) => state.app.menuList,
    }),
  },
  methods: {
    ...mapMutations(["SET_PROJECT_ID", "SET_PROJECT_TITLE"]),
    changeMenu(active) {
      this.activeStr = active;
      this.url = active;
      console.log(this.url, "动态跳转路由");
      this.isDownClock = true;
      this.routerName = active.substring(active.indexOf("-") + 1);
      this.projectId = active.substring(0, active.indexOf("-"));
      this.$emit("changeShow", this.routerName);
      this.$emit("changeDpwm", this.isDownClock);

      this.backTop();
      this.$emit("on-change", this.routerName, this.projectId);
    },
    menuResize() {
      this.$emit("on-open-change");
    },
    backTop() {
      let pageContent = document.querySelector(".single-page-con");
      pageContent.scrollTop = 0;
    },
    // 修改导航栏状态
    changeMenuAnalysis(v) {
      if (typeof v == "boolean") {
        if (!v) {
          if (this.url.indexOf("event_analysis") > -1) {
            this.$emit("changeShow", false);
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          } else if (this.url.indexOf("distribution-analysis") > -1) {
            this.$emit("changeShow", false);
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          } else if (this.url.indexOf("funnel-analysis") > -1) {
            this.$emit("changeShow", false);
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          } else if (this.url.indexOf("user-behavior-path") > -1) {
            this.$emit("changeShow", false);
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          } else if (this.url.indexOf("retention-analysis") > -1) {
            this.$emit("changeShow", false);
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          } else if (this.url.indexOf("interval_analysis") > -1) {
            this.$emit("changeShow", false);
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          } else if (this.url.indexOf("ltv-analysis") > -1) {
            this.$emit("changeShow", false);
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          } else if (this.url.indexOf("attribution_analysis") > -1) {
            this.$emit("changeShow", false);
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          } else {
            this.routerName = this.routerName;
            this.projectId = this.projectId;
          }
        } else {

          console.log(this.menuList, 'aa1123?')
          this.changeMenuAnalysis(false);
          return
          this.url = window.location.href;
          if (this.url.indexOf("event_analysis") > -1) {
            this.routerName = "event_analysis";
            this.projectId = 5;

          } else if (this.url.indexOf("distribution-analysis") > -1) {
            this.routerName = "distribution-analysis";
            this.projectId = 718;
            this.changeMenuAnalysis(false);
          } else if (this.url.indexOf("funnel-analysis") > -1) {
            this.routerName = "funnel-analysis";
            this.projectId = 707;
            this.changeMenuAnalysis(false);
          } else if (this.url.indexOf("user-behavior-path") > -1) {
            this.routerName = "user-behavior-path";
            this.projectId = 838;
            this.changeMenuAnalysis(false);
          } else if (this.url.indexOf("retention-analysis") > -1) {
            this.routerName = "retention-analysis";
            this.projectId = 941;
            this.changeMenuAnalysis(false);
          } else if (this.url.indexOf("interval_analysis") > -1) {
            this.routerName = "interval_analysis";
            this.projectId = 921;
            this.changeMenuAnalysis(false);
          } else if (this.url.indexOf("ltv-analysis") > -1) {
            this.routerName = "ltv-analysis";
            this.projectId = 953;
            this.changeMenuAnalysis(false);
          } else if (this.url.indexOf("attribution_analysis") > -1) {
            this.routerName = "attribution_analysis";
            this.projectId = 1008;
            this.changeMenuAnalysis(false);
          }
        }
      } else {
        this.$emit("changeShow", false);
      }
    },
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.sideMenu) {
        this.$refs.sideMenu.updateOpened();
      }
    });
  },
  watch: {
    menuShow(v) {
      this.changeMenuAnalysis(v);
    },
    isDown(v) {
      if (!v) {
        this.routerName = "";
        this.projectId = 0;
        this.isDownClock = true;
        this.changeMenuAnalysis(false);
      } else {
        this.url = window.location.href;
        if (this.url.indexOf("event_analysis") > -1) {
          this.routerName = "event_analysis";
          this.projectId = 5;
          this.changeMenuAnalysis(false);
        } else if (this.url.indexOf("distribution-analysis") > -1) {
          this.routerName = "distribution-analysis";
          this.projectId = 718;
          this.changeMenuAnalysis(false);
        } else if (this.url.indexOf("funnel-analysis") > -1) {
          this.routerName = "funnel-analysis";
          this.projectId = 707;
          this.changeMenuAnalysis(false);
        } else if (this.url.indexOf("user-behavior-path") > -1) {
          this.routerName = "user-behavior-path";
          this.projectId = 838;
          this.changeMenuAnalysis(false);
        } else if (this.url.indexOf("retention-analysis") > -1) {
          this.routerName = "retention-analysis";
          this.projectId = 941;
          this.changeMenuAnalysis(false);
        } else if (this.url.indexOf("interval_analysis") > -1) {
          this.routerName = "interval_analysis";
          this.projectId = 921;
          this.changeMenuAnalysis(false);
        } else if (this.url.indexOf("ltv-analysis") > -1) {
          this.routerName = "ltv-analysis";
          this.projectId = 953;
          this.changeMenuAnalysis(false);
        } else if (this.url.indexOf("attribution_analysis") > -1) {
          this.routerName = "attribution_analysis";
          this.projectId = 1008;
          this.changeMenuAnalysis(false);
        }
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/components/sidebarMenu.vue